import BusinessRegistration from '../pages/BusinessRegistration.vue';
const businessRegistrationRoutes = [
  {
    path: '/business-registration',
    name: 'فرم ثبت نام',
    component: BusinessRegistration,
    meta: {
      layout: 'RegisterLayout',
      roles: ['registration'],
    },
  },
];

export default businessRegistrationRoutes;
